// extracted by mini-css-extract-plugin
module.exports = {"wrap":"T_c1","phone":"T_c2","phone-link":"T_c3","phoneLink":"T_c3"};